var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

export default invariant;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/tiny-invariant/dist/tiny-invariant.esm.js
// module id = 228
// module chunks = 2 3 4 5 10 11 15